import { h, Component, RefObject } from 'preact';
import cx from 'classnames';
import { Subject } from 'rxjs';

import { Form } from '../../../../utils/forms/form';
import hopplerLinkState from '../../../../utils/forms/hoppler-linkstate';

interface ListingEditorStatusSectionProps {
  form?: Form;
  formSubject?: Subject<Form>;
  onHoldRef?: RefObject<any>;
}

interface ListingEditorStatusSectionState {}

export class ListingEditorStatusSection extends Component<ListingEditorStatusSectionProps, ListingEditorStatusSectionState> {

  render() {

    const { form, formSubject, onHoldRef } = this.props;
    
    const feStatus = form.fields['feStatus'].value
    const statusArr = ['Available', 'On Hold', 'Sold'];
    const disableArr = ['Draft', 'Expired', 'For Approval', 'Declined']

    return (
      <div className="mt-3">
        <div className={ cx("hi-input-group", {
          'd-none': disableArr.includes(feStatus)
        }) }>
          <label className="hi-input-group__label">Property Status</label>
          <select
            disabled={ disableArr.includes(feStatus) }
            value={ feStatus }
            onChange= { hopplerLinkState(formSubject, form, 'feStatus') }
            className="form-control hi-text-input">
          {
            statusArr.map(status => (
              <option value={ status }>{ status }</option>
            ))
          }
          </select>
        </div>

        <div className={ cx('hi-input-group mt-2', {
          'd-none': feStatus !== 'On Hold'
        }) }>
          <label className="hi-input-group__label">On Hold Reason</label>
          <input
            ref={ onHoldRef }
            placeholder="On hold reason"
            value={ form.fields['onHoldReason'].value }
            onInput={ hopplerLinkState(formSubject, form, 'onHoldReason') }
            type="text" 
            className="form-control hi-input-text"/>
        </div>

        
        
      </div>
    )
  }
}